const  play_base_url = process.env.play_base_url
export const personalTelecelPlayChildren = [
    {
      label: "Account Management",
      icon: "register",
      url: "#",
      children: [
        {
          label: "Dashboard",
          url: `${play_base_url}/dashboard/`,
          children: [],
        },
        {
          label: "Account Details/Subscriptions",
          url: `${play_base_url}/account-details/`,
          children: [],
        },
        {
          label: "Make Payments",
          url: `${play_base_url}/pay/`,
          children: [],
        },
      ],
    },
    {
      label: "Offers & Packages",
      icon: "register",
      url: "#",
      children: [
        {
          label: "Voice & Data Bundles",
          url: "/personal/mobile/offers/bundles/",
          children: [],
        },
        {
          label: "Airtime Top-Up",
          url: "/personal/mobile/offers/top-up/",
          children: [],
        },
      ],
    },
    {
      label: "Requests",
      url: "#",
      icon: "roaming-system",
      children: [
        {
          label: "Call Detail Records",
          url: `${play_base_url}/cdr-request/`,
          children: [],
        },
        {
          label: "PUK Requests",
          url: `${play_base_url}/mobile/puk/`,
          children: [],
        },
      ],
    },
    {
      label: "Broadband Management",
      url: "#",
      icon: "roaming-system",
      children: [
        {
          label: "Data Usage",
          url: `${play_base_url}/data-usage/`,
          children: [],
        },
        {
          label: "Data Sharing",
          url: `${play_base_url}/fixed/data-sharing/`,
          children: [],
        },
        {
          label: "Generate Receipt",
          url: `${play_base_url}/generate-receipt/`,
          children: [],
        },
        {
          label: "Add On Bundles",
          url: "/personal/broadband/offers/bundles/",
          children: [],
        },
        {
          label: "Plan Change",
          url: "/personal/broadband/offers/bundles/",
          children: [],
        },
   
      ],
    },
    {
      label: "Support",
      url: "#",
      icon: "roaming-system",
      children: [
        {
          label: "Report a fault",
          url: `${play_base_url}/faults/reporting/`,
          children: [],
        },
        {
          label: "Track fault",
          url: `${play_base_url}/faults/tracking/`,
          children: [],
        },
        // {
        //   label: "FAQs",
        //   url: "#",
        //   children: [],
        // },
      ],
    },
  ]